import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80c1ceba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero is-fullheight p-6" }
const _hoisted_2 = { class: "container has-background-light is-flex is-flex-direction-column is-justify-content-center is-align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "control mt-4" }
const _hoisted_6 = { class: "select is-info" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "en" }, "en", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "pt-BR" }, "pt-BR", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "pt" }, "pt", -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "control has-icons-left has-icons-right" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "control has-icons-left" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "control has-text-centered" }
const _hoisted_19 = { class: "field" }
const _hoisted_20 = { class: "control has-text-centered" }
const _hoisted_21 = { class: "field" }
const _hoisted_22 = { class: "control has-text-centered has-text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: _ctx.logoPath,
          class: "image logo-image",
          alt: "logo"
        }, null, 8, _hoisted_3)
      ]),
      (_ctx.showLanguageSwitcher)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLanguage) = $event)),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeLanguage && _ctx.changeLanguage(...args)))
                }, _hoisted_10, 544), [
                  [_vModelSelect, _ctx.selectedLanguage]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"])),
        class: "p-3"
      }, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "email",
              placeholder: _ctx.$t('General.EmailPlaceholder'),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
              required: ""
            }, null, 8, _hoisted_13), [
              [_vModelText, _ctx.email]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              class: "input",
              type: "password",
              placeholder: _ctx.$t('General.PasswordPlaceholder'),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
              required: ""
            }, null, 8, _hoisted_16), [
              [_vModelText, _ctx.password]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", _hoisted_18, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-success is-fullwidth", { 'is-loading': _ctx.isChecking }])
            }, _toDisplayString(_ctx.$t('General.Login')), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", _hoisted_20, [
            _createElementVNode("button", {
              class: _normalizeClass(["button is-success is-fullwidth is-light", { 'is-loading': _ctx.isChecking }])
            }, [
              _createElementVNode("a", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.registerCustomer && _ctx.registerCustomer(...args)))
              }, _toDisplayString(_ctx.$t('Customer.NewCustomer')), 1)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("p", _hoisted_22, [
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToResetPassword && _ctx.goToResetPassword(...args)))
            }, _toDisplayString(_ctx.$t('General.ResetPassword')), 1)
          ])
        ])
      ], 32)
    ])
  ]))
}